import $ from 'jquery';

// hide hidden fields parents
var formHiddenInputs = setInterval(function(){
  if($('.hbspt-form').length){
    //$('.hbspt-form input[name=page_url]').val(window.location.href);

    // /english-sales-jobs-in-montreal
    if($('body').hasClass('postid-38405')){
      $('input[name=utm_campaign]').val('Careers - English sales jobs in Montreal');
      $('input[name=utm_source]').val('ppc');
      $('input[name=utm_medium]').val('landing page');
      $('input[name=utm_term]').val('montreal-recruitment');
      $('input[name=utm_content]').val('form-submission');
    }

    clearInterval(formHiddenInputs);
  }
});

var bestDaytoCallInput = setInterval(function () {
  if ($('input[name=best_day_to_call]').length) {
    if($('input[name=best_day_to_call]').val() != ''){
      $('input[name=best_day_to_call]').parents('.hs-fieldtype-date').find('label').hide();
      //clearInterval(bestDaytoCallInput);
    } else {
      $('input[name=best_day_to_call]').parents('.hs-fieldtype-date').find('label').show();
    }
  }
}, 100);

const dynamicValue = window.location.href;
window.addEventListener('message', event => {
  if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
    console.log("LOC: ", dynamicValue);
    const hiddenField = document.querySelector('input[name="page_url"]');

    if (hiddenField) {
      hiddenField.value = dynamicValue;
    }
  }
});

$(document).on('input change', '.edge-calculator #avg_trans_amt', function(){
  if($(this).val() != '' && $(this).val().length > 1){
    // $4.99 charge for every $100
    var ratio = parseInt($(this).val()) / 100;
    var charge = 4.99 * ratio;
    $('.edge-calculator .data-output.avg-trans').html('$' + charge.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}));
  } else {
    $('.edge-calculator .data-output.avg-trans').html('$0.00');
  }
});

$(document).on('input change', '.edge-calculator #monthly_process_vol', function(){
  if($(this).val() != '' && $(this).val().length > 1){
    // $40 cashback for every $10000
    var ratio = parseInt($(this).val()) / 10000;
    var monthly = 40 * ratio;
    var quarterly = monthly * 3;
    var yearly = monthly * 12;
    $('.edge-calculator .data-output.monthly-cashback').html('$' + monthly.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}));
    $('.edge-calculator .data-output.quarterly-cashback').html('$' + quarterly.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}));
    $('.edge-calculator .data-output.annual-cashback').html('$' + yearly.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}));
  } else {
    $('.edge-calculator .data-output.monthly-cashback, .edge-calculator .data-output.quarterly-cashback, .edge-calculator .data-output.annual-cashback').html('$0.00');
  }
});

$(document).on('mouseenter', '.edge-calculator .tool-tip', function(){
  const rect = this.getBoundingClientRect();
  //console.log('WINDOW WIDTH DIVIDED IN HALF: ', window.innerWidth, 'X POSITION: ', rect.x);
  if(rect.x > (window.innerWidth / 2)){
    $(this).find('.tool-tip-desc').css({'left': 'auto', 'right': '10px'})
  } else {
    $(this).find('.tool-tip-desc').css({'left': '10px', 'right': 'auto'})
  }
});

/*$(document).on('load', '.hbspt-form input[name=page_url]', function(){
  $('.hbspt-form input[name=page_url]').val(window.location.href);
});
*/

// hubspot submit button
var hubspotSubmitButtonStyles = setInterval(function () {
  if ($('div.hs_submit').length > 0) {
    $('div.hs_submit').addClass('hover-styles');
    $('div.hs_submit').each(function () {
      if (!$(this).parents('#footer').length && !$(this).parents('.popup').length) {
        var submitWrap = $(this).find('.actions');
        var submit = $(this).find('input[type=submit]');
        var label = submit.val();
        submit.remove();

        var bgColour = 'section-color-white';

        if (
          $(this).parents('.callback-popup-form').length ||
          $(this).parents('.talk-to-us-block-popup-form').length ||
          $(this).parents('.form--container').length ||
          $(this).parents('.popup-form').length
        ) {
          var bgColour = 'section-color-blue';
        }

        submitWrap.append(
          '<button type="submit" class="hs-button primary large btn-default size-18-txt ltr-spc-pos-0_25 c-blue-1 btn-green-1 btn-offset-10 fw-700 ' +
            bgColour +
            '" value="' +
            label +
            '"><span class="btn-bg-el"></span><span class="btn-txt">' +
            label +
            '</span></button>',
        );
      }
    });
    clearInterval(hubspotSubmitButtonStyles);
  }
}, 500);

// Add Aria Labels to Hubspot forms
var hubspotFormsAriaLabels = setInterval(function () {
  if ($('.hbspt-form form').length) {
    let form = $('.hbspt-form form');
    form.removeAttr('id');
    let inputs = form.find('input');
    let selects = form.find('select');

    inputs.each(function (index) {
      if (
        $(this).attr('type') != 'hidden' ||
        $(this).attr('name') == 'page_url' ||
        $(this).attr('name') == 'g-recaptcha-response'
      ) {
        let inputID = $(this).attr('id') + '-' + index;
        var inputName = $(this).parents('.input').siblings('label').attr('placeholder');
        if(inputName == '') {
          var inputName = $(this).attr('name') + '-' + index;
        }

        $(this)
          .parents('.input')
          .siblings('label')
          .attr('aria-label', inputName);
        $(this).parents('.input').siblings('label').removeAttr('id');
        $(this).parents('.input').siblings('label').attr('for', inputID);
        $(this).attr('id', inputID);
      }
    });

    selects.each(function (index) {
      let inputID = $(this).attr('id') + '-' + index;
      var inputName = $(this).parents('.input').siblings('label').attr('placeholder');
      if(inputName == '') {
        var inputName = $(this).attr('name') + '-' + index;
      }

      $(this)
        .parents('.input')
        .siblings('label')
        .attr('aria-label', inputName);
      $(this).parents('.input').siblings('label').removeAttr('id');
      $(this).parents('.input').siblings('label').attr('for', inputID);
      $(this).attr('id', inputID);
    });

    clearInterval(hubspotFormsAriaLabels);
    //console.log('aria labels added to hubspot forms');
  }
}, 100);

// Hubspot errors listener, updates ul role attribute to list
/*
setInterval(function () {
  if ($('.hbspt-form ul').length > 0) {
    $('.hbspt-form ul').attr('role', 'list');
    $('.hbspt-form ul[role=list] li').attr('role', 'listitem');
  }
}, 250);
*/

// edit placeholder text for subscribe form in footer
var hubspotFormSubscribeEmailField = setInterval(function () {
  if ($('footer .hbspt-form input[name=email]').length) {
    // console.log('testing for email field on mobile');
    clearInterval(hubspotFormSubscribeEmailField);
    if ($('html').attr('lang') == 'es-US') {
      $('footer .hbspt-form input[name=email]').attr(
        'placeholder',
        'Suscríbete a nuestro boletín',
      );
    } else if ($('html').attr('lang') == 'fr-CA') {
      $('footer .hbspt-form input[name=email]').attr(
        'placeholder',
        'Inscrivez-vous à notre newsletter',
      );
    } else {
      $('footer .hbspt-form input[name=email]').attr(
        'placeholder',
        'Sign up for our newsletter',
      );
    }
  }
}, 100);

// survey section download guide popup button
$('.download-open-form-btn').on('click', function(e) {
  e.preventDefault();
  if ($('.newsletter-form .hbspt-form').length) {
    $('.newsletter-form .hbspt-form')
      .detach()
      .appendTo('.download-popup-form .form-wrap');
  }
});
$('.form-popup-close-btn').on('click', function(e) {
  if ($('.download-popup-form .hbspt-form').length) {
    $('.download-popup-form .form-wrap .hbspt-form')
      .detach()
      .appendTo('.contact-block .newsletter-form');
  }
});

const listenInputChange = (el) => {
  if ($(el).is(':visible')) {
    const input = $(el).attr('for');
    // console.log($(`#${input}`));
    $(`#${input}`).on('keyup', (inpt) => {
      // console.log('change', inpt, $(`#${input}`).val());
      // console.log(inpt.target.value);
      if (inpt.target.value) {
        $(el).addClass('filled');
      } else {
        $(el).removeClass('filled');
      }
    });
  }
};

const observeFormInput = (selector, className, listenInputChange) => {
  const targetNodes = document.querySelectorAll(selector);

  targetNodes.forEach((targetNode) => {
    if (!targetNode) {
      console.error('Target node not found');
      return;
    }

    const config = { childList: true, subtree: true };

    const callback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          if (!targetNode.classList.contains(className)) {
            //console.log(className);
            targetNode
              .querySelectorAll('label')
              .forEach((el) => listenInputChange(el));
            targetNode.classList.add(className);
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  });
};

if ($('.home-page-form').length) {
  var formCheck = setInterval(function(){
    if($('.home-page-form .hs-input').length && $('.home-page-form .hs-input').val() != ''){
      $('.home-page-form .hs-input').each(function(i){
        if($(this).val != ''){
          $(this).parents('.input').siblings('label').addClass('filled');
        }
      });
      clearInterval(formCheck);
    }
  }, 500);
  observeFormInput(
    '.form-contact-section-home .home-page-form:not(.sk-form-hbsp-ltd)',
    'sk-form-hbsp-ltd',
    listenInputChange,
  );
}
